"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = void 0;
var Size;
(function (Size) {
    Size["ONE_TO_TEN"] = "ONE_TO_TEN";
    Size["ELEVEN_TO_TWENTY"] = "ELEVEN_TO_TWENTY";
    Size["TWENTY_ONE_TO_FIFTY"] = "TWENTY_ONE_TO_FIFTY";
    Size["MORE_FIFTY"] = "MORE_FIFTY";
})(Size || (Size = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["ACTIVE"] = "ACTIVE";
    Status["DISABLED"] = "DISABLED";
    Status["REJECTED"] = "REJECTED";
    Status["NONE"] = "NONE";
})(Status || (Status = {}));
var PlanStatus;
(function (PlanStatus) {
    PlanStatus["ACTIVE"] = "ACTIVE";
    PlanStatus["INACTIVE"] = "INACTIVE";
})(PlanStatus || (PlanStatus = {}));
var Autocomplete;
(function (Autocomplete) {
    Autocomplete["ACTIVE"] = "ACTIVE";
    Autocomplete["INACTIVE"] = "INACTIVE";
})(Autocomplete || (Autocomplete = {}));
var Type;
(function (Type) {
    Type["WORK_COMPANY"] = "WORK_COMPANY";
    Type["INSTITUTION"] = "INSTITUTION";
})(Type || (Type = {}));
var FinancialType;
(function (FinancialType) {
    FinancialType["PUBLIC"] = "PUBLIC";
    FinancialType["PRIVATE"] = "PRIVATE";
    FinancialType["SOCIAL"] = "SOCIAL";
    FinancialType["NONPROFIT"] = "NONPROFIT";
})(FinancialType || (FinancialType = {}));
var SocialMedia;
(function (SocialMedia) {
    SocialMedia["LINKEDIN_COMPANY"] = "LINKEDIN_COMPANY";
    SocialMedia["FACEBOOK"] = "FACEBOOK";
    SocialMedia["INSTAGRAM"] = "INSTAGRAM";
    SocialMedia["GITHUB"] = "GITHUB";
})(SocialMedia || (SocialMedia = {}));
exports.enums = {
    status: Status,
    type: Type,
    financialType: FinancialType,
    planStatus: PlanStatus,
    autocomplete: Autocomplete,
    socialMedias: SocialMedia,
};
//# sourceMappingURL=Company.js.map